<div class="modal-box-large">
    <h4>Ricerca Soggetto</h4>
    <div class="form-container">
        <app-basic-card>
            <app-basic-form [form]="searchForm" [keys]="searchFormKeys"></app-basic-form>
            <button mat-raised-button color="primary" (click)="onSearchClick()" [disabled]="!searchForm.valid">{{'ricerca' | uppercase}}</button>
            <button mat-button color="warn" class="mx-3" (click)="reset()">{{'reset' | uppercase}}</button>
        </app-basic-card>
        <div class="mt-3" *ngIf="searchedSubjectRecap">
            <app-policy-card [item]="searchedSubjectRecap" [keys]="searchedSubjectRecapKeys" [title]="subjectTitle" [tooltip]="'Soggetto ricercato'"></app-policy-card>
        </div>
    </div>
    <div class="d-flex justify-content-between mt-3">
        <button mat-raised-button [color]="'warn'" (click)="close('CLOSE')">Chiudi</button>
        <button mat-raised-button [color]="'primary'" [disabled]="!searchedSubject" (click)="close('CONFIRM')">Conferma</button>
    </div>
</div>